import { useNavigate } from "react-router-dom";
import AnimatedBackground from "../components/assets/backgrounds/AnimatedBackground";
import Header from "../components/Header";
import { quickActions } from "../const/quickActions";
import { ActionButtonHome } from "./ActionButtonHome";
import { useAuth } from "../context/AuthContext";
import { dictionary, Language } from "../utils/dictionary";

const HomePage = () => {
  const navigate = useNavigate();
  const { isUserFake, language } = useAuth();

  const handleClick = (path: string) => {
    // if (path === "/onboarding" && isUserFake) {
    //   navigate("/onboarding1");
    // } else {
      navigate(path);
    // }
  };

  const idCreateNewFunnel = "createSalesPage-target";

  return (
    <div className="min-h-screen px-24 pt-16 font-['Plus_Jakarta_Sans'] flex flex-col">
      <AnimatedBackground />
      <div className="relative z-10 flex-1 flex flex-col">
        {/* Header Section */}
        <div className="flex justify-between w-full items-center">
          <Header />
        </div>

        <div className="flex-1 flex justify-between w-full mt-20">
          {/* Title */}
          <div className="flex flex-col w-[40%]">
            <h2 className="text-2xl font-semibold text-[#6A6A6A] mb-8">
              {dictionary["question-home"][language as Language]}
            </h2>
            {/* Actions Grid */}
            <div className="w-full flex flex-col gap-4">
              {quickActions(language).map((action, index) => (
                <div id={action.path === "/onboarding" ? idCreateNewFunnel : ""} key={index} className="w-full max-h-max">
                  <ActionButtonHome
                    title={action.title}
                    icon={action.icon}
                    onClick={() => handleClick(action.path)}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="w-[50%] flex items-end 4xl:items-start">
            <img
              src="https://fluxi.co/prod/assets/images/official-fluxi-mascot-6.webp"
              alt="Fluxi Mascot"
              className="w-full h-auto object-bottom"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
